import type { ContenidoAyuda } from "@/ui/AyudaVista";

/**
 * Ayuda de «Nuevo caso» (`components/NuevoCasoModal`), con lo que antes iba en
 * los tooltips de sus selectores (cliente, marca y modelo). Los campos se
 * explican en línea, bajo cada uno; aquí van los botones y los avisos.
 */
export function ayudaNuevoCaso({ relacionado }: { relacionado: boolean }): ContenidoAyuda {
  return {
    manual: relacionado ? "hilos" : "casos",
    intro: (
      <p>
        {relacionado
          ? "Abre un caso nuevo que continúa el hilo del anterior: cliente, equipo e IMEIs vienen precargados; ajústalos si algo cambió."
          : "Da de alta un caso."}{" "}
        Solo el cliente es obligatorio (y el tipo de falla, si la categoría es Falla). El TE se
        genera solo al guardar.
      </p>
    ),
    secciones: [
      {
        titulo: "Qué hace cada botón",
        items: [
          {
            label: "Cliente",
            text: "Escribe para buscar entre los clientes. Si no existe, «+ Crear cliente nuevo: …» lo da de alta en ese momento, en una ventanita con el nombre (no al guardar el caso).",
          },
          { label: "× junto al cliente", text: "Quita el cliente elegido para buscar otro." },
          {
            label: "+ junto a Marca / Modelo",
            text: "Crea una marca o un modelo nuevo en el catálogo y lo elige. El «+» del modelo sale gris hasta que eliges marca. Si escribes un modelo parecido a uno que ya existe, te lo enseña con «Usar este».",
          },
          {
            label: "Agregarla / Agregarlo",
            text: "Sale cuando la marca o el modelo vienen escritos a mano y no están en el catálogo: los agrega.",
          },
          {
            label: "+ Agregar modelo",
            text: "Para un caso con equipos de varios modelos. El primero es el principal.",
          },
          { label: "✕ junto a un modelo", text: "Lo quita. Sale cuando hay más de uno." },
          {
            label: "+ Nuevo (contacto)",
            text: "Registra un contacto nuevo en la ficha del cliente y lo deja elegido para el caso. Sale después de elegir cliente.",
          },
          {
            label: "Crear caso",
            text: "Guarda el caso. Si ya hay casos con alguno de esos IMEIs, antes te pregunta: «Revisar antes» o «Crear de todos modos».",
          },
          { label: "Cancelar", text: "Cierra. Si ya escribiste algo, pregunta antes de descartarlo." },
        ],
      },
      {
        titulo: "Qué significa cada indicador",
        items: [
          {
            label: "⚠️ Ya existe un caso con este IMEI",
            text: "Otro caso trae alguno de esos IMEIs; dice su estado o hace cuánto se cerró. Tócalo para abrirlo en otra pestaña. Si es el mismo problema, sigue ese en vez de crear otro.",
          },
          {
            label: "✓ / ⚠️ en nuestras ventas",
            text: "Si esos equipos aparecen en Ventas. Solo informa: puede que el mes aún no esté cargado. Nunca bloquea.",
          },
          { label: "N IMEIs detectados", text: "Cuántos IMEIs distintos leyó de lo que pegaste." },
          {
            label: "(libre) · (descontinuada)",
            text: "En Marca o Modelo: «libre» es un nombre escrito a mano que no está en el catálogo; «descontinuada» o «descontinuado», uno que ya no se ofrece para casos nuevos.",
          },
        ],
      },
      {
        titulo: "Atajos de teclado",
        items: [
          {
            label: "Enter",
            text: "En el buscador de cliente, elige el primero de la lista (o abre «Crear cliente nuevo» si no hay coincidencias).",
          },
          { label: "Esc", text: "En el buscador de cliente, cierra la lista." },
          { label: "↓", text: "En el buscador de cliente, abre la lista." },
        ],
      },
    ],
  };
}
